import {AjaxResponse, ajax} from 'rxjs/ajax';
import {Observable} from 'rxjs';
import {isEmpty, template} from 'lodash';
import {buildHttpRequestHeader, buildHttpUrl} from '@app/utils';

interface Api {
  url: string;
  method: string;
  auth: boolean;
}

interface CreateMultipartRequestParams {
  api: Api;
  body?: any;
  token?: string;
  params?: any;
}

interface CreateRequestParams {
  api: Api;
  body?: any;
  token?: string;
  params?: any;
}

export const createMultipartRequest = ({
  api,
  body,
  token,
  params,
}: CreateMultipartRequestParams): Observable<AjaxResponse<any>> => {
  return create(api, body, token, params, 'multipart/form-data');
};

export const createRequest = ({
  api,
  body,
  token,
  params,
}: CreateRequestParams): Observable<AjaxResponse<any>> => {
  return create(api, body, token, params, 'application/json');
};

const create = (
  api: Api,
  body: any,
  token: string = '',
  params: any,
  contentType: string,
): Observable<AjaxResponse<any>> => {
  let url = api.url;
  if (params !== null && params !== undefined) {
    url = template(url)(params);
  }

  if (isEmpty(token)) {
    token = '';
  }

  const headers = buildHttpRequestHeader({isAuth: api.auth, token, contentType});

  if (api.method === 'POST' || api.method === 'PUT') {
    return ajax({
      url: buildHttpUrl(url),
      method: api.method,
      headers: headers,
      body: body,
    });
  } else {
    return ajax({
      url: buildHttpUrl(url),
      method: api.method,
      headers: headers,
    });
  }
};
